var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('list-form',{ref:"list-form",attrs:{"formModel":_vm.formModel,"config":_vm.config},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
var item = ref.item;
var updateDataItem = ref.updateDataItem;
var autoSave = ref.autoSave;
return [_c('activity-item',{attrs:{"data":data,"item":item,"formModel":_vm.formModel,"autoSave":autoSave},on:{"change":updateDataItem,"onSendEmail":_vm.handlerSendEmail,"updatedData":_vm.refresh,"onStockCard":_vm.handlerStockCard}})]}}])}),_c('dialog-stock-card',{ref:"dialog-stock-card"}),_c('dialog-new-instruction-customer'),_c('dialog-status-customer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }